import { createNamespacedHelpers } from 'vuex';
import BaseStore from '@/store';
import state from './orderTemplates.state';
import getters from './orderTemplates.getters';
import actions from './orderTemplates.actions';
import mutations from './orderTemplates.mutations';

BaseStore.registerModule('orderTemplates', {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
});

export default BaseStore;

let { mapState, mapGetters, mapActions, mapMutations } = createNamespacedHelpers('orderTemplates');

export {
	mapState,
	mapGetters,
	mapActions,
	mapMutations
};